import {
    CLEAR_TRANSFER_SHARE_CONFIG,
    FETCH_TRANSFER_SHARE_CONFIG,
    LIST_TRANSFER_SHARE_CONFIG
} from "./types";

const init = {
    isLoading: false,
    list: [],
    page: 0,
    size: 50,
    totals: 0,
    filter: {
        page: 1,
        size: 50,
        filterByLevel: "super-senior",
        filterByLotteryType: "",
        query: ""
    }
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_TRANSFER_SHARE_CONFIG:
            return {
                ...state,
                isLoading: true,
                filter: payload
            };
        case LIST_TRANSFER_SHARE_CONFIG:
            return {
                ...state,
                isLoading: false,
                list: payload.list ?? [],
                page: payload.page ?? state.page,
                size: payload.size ?? state.size,
                totals: payload.totals ?? state.totals,
                filter: payload.filter ?? state.filter
            };
        case CLEAR_TRANSFER_SHARE_CONFIG:
            return {
                ...init
            };
        default:
            return state;
    }
};
